import script from "./NavbarComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarComponent.vue?vue&type=script&setup=true&lang=js"

import "./NavbarComponent.vue?vue&type=style&index=0&id=04bd85b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04bd85b4"]])

export default __exports__